export const environment = {
  production: true,
  name: 'dev',
  target: 'hosting',
  offline: false,
  emulators: {
    auth: false,
    firestore: false,
    storage: false,
    functions: false,
  },
  repairMode: true,
  firebase: {
    apiKey: 'AIzaSyCf98rVO8dC0PWCsxT94CBQTiBxVHggU2A',
    authDomain: 'dev-damotech-platform.firebaseapp.com',
    databaseURL: 'https://dev-damotech-platform.firebaseio.com',
    projectId: 'dev-damotech-platform',
    storageBucket: 'dev-damotech-platform.appspot.com',
    messagingSenderId: '316911716275',
    appId: '1:316911716275:web:de3917e3bf79ef3610edc6',
    measurementId: 'G-2VTPRL02JM',
  },
  appConfig: {
    domain: '.2totems.com',
    faqUrlEn: 'https://www.damotech.com/en/knowledge/logging-in',
    faqUrlFr: 'https://www.damotech.com/fr/knowledge/ouvrir-une-session',
    helpDeskUrl: 'https://www.damotech.com/knowledge/kb-tickets/new',
    websiteUrl: 'https://www.damotech.com',
    signupUrl: {
      en: 'https://www.damotech.com/software/watch-the-demo-video-lp',
      fr: 'https://www.damotech.com/fr/reserver-une-demo-de-la-plateforme-lp',
    },
    ngFnsOrigin: 'https://dev-damotech-platform.web.app',
    fns: 'https://platform-dev.2totems.com/api',
    production: {
      bucket: {
        drawings: 'dev-damotech-platform.appspot.com',
      },
      mesUrl: '',
      mesHealthCheckUrl: '',
      pubSubPrefix: 'dev-',
    },
    watson: {
      bucket: {
        drawings: 'dev-damotech-platform.appspot.com',
        import: 'dev-damotech-platform.appspot.com',
        importWork: 'dev-imports-work',
      },
      layoutDebugInfos: false,
      maxDownloadChunkSize: 10,
      maxSyncingWarehouses: 5,
      minSyncingDelay: 3600,
      maxSyncEventReplay: 500,
      pubsub: {
        import: 'dev-imports',
      },
      useWebworkers: false,
      downloadPicturesOnSync: false,
      // SC-9665: historical warehouse state snapshots. Online-only; off in production.
      warehouseStateSnapshots: true,
      sectionLayoutMode: true,
    },
    storage: {
      enabled: true,
      bucket: 'dev-damotech-platform.appspot.com',
    },
    upload: {
      maxFileSize: 2048 * 1024 * 1024,
    },
    router: {
      history: 100,
    },
    heartbeatUrl: 'https://firebasestorage.googleapis.com/v0/b/prod-tokyo-concept-157620/o/public%2Fhealthcheck.txt',
    hubspotPortalId: '44306683',
  },
  home: 'https://platform-dev.2totems.com',
  recaptcha: {
    siteKey: '6LeqJScjAAAAACcWsmtSRFye-kzgUHKB7d-dfkGe',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/d
